package login

import org.koin.dsl.module

fun loginKoinModule() = module {
    single { CredentialsStore() }
    single { ResetPasswordDataStore() }
}
